export default function CFormatSpecifiers() {
  return <h2>C Format Specifiers</h2>;
}
